export const startsWithASingleSlash = /^\/(?!\/)/;
